// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"0d9bf58c","450":"9b28b61d","453":"5c3335af"}[chunkId] + ".chunk.js";
};